const THREE = (globalThis as any).THREE;

export class ForgeTools {
    viewer;

    constructor(viewer: any) {
        this.viewer = viewer
    }
    
    createMesh(options:any) {
        
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const material = new THREE.MeshPhongMaterial({ color: 0x00aaff });
        const mesh = new THREE.Mesh(geometry, material);

        return mesh;
    }

    addObject(overlayName: string, mesh: any): void {

        if (!this.viewer.impl.overlayScenes[overlayName]) {
            this.viewer.impl.createOverlayScene(overlayName);
        }

        this.viewer.impl.addOverlay(overlayName, mesh);
        this.viewer.impl.invalidate(true);
    }

    removeObject(overlayName:string, mesh: any): void {
        this.viewer.impl.removeOverlay(overlayName, mesh);
        this.viewer.impl.invalidate(true);
    }
    
    getFragIds(dbId: number) {
        const model = this.viewer.model;
        const it = model.getInstanceTree();
        const fragIds: string[] = [];

        it.enumNodeFragments(dbId, (fragId: string) => {
            fragIds.push(fragId);
        });

        return fragIds;
    }
    setMaterial(dbId: number, materialName: string) {
        const fragIds = this.getFragIds(dbId);

        fragIds.forEach(fragId => {
            this.viewer.impl.setMaterial(fragId, materialName);
        });

        this.viewer.impl.invalidate(true);
    }
    hexToVector4(hex: string, alpha = 1): THREE.Vector4 {
        const color = new THREE.Color(hex); // convertit automatiquement
        return new THREE.Vector4(color.r, color.g, color.b, alpha);
    }
    setColor(dbId: number, color: THREE.Vector4 = new THREE.Vector4(1, 0, 0, 1)) {
        this.viewer.setThemingColor(
            dbId,
            color
        );
    }

    loadTextures(names: string[]) {
        let promises: any[] = []
        names.forEach(key => {
            promises.push(new Promise((res) => {
                new THREE.TextureLoader().load(`/img/metric-icons/${key}.jpg`,
                    (texture: THREE.Texture) => {
                        texture.name = key;
                        res(texture)
                    });
            }))
        })
        return Promise.all(promises);
    }
}